import { Divider, Typography } from '@mui/material'
import React from 'react'
import Tablausers from '../usuarios/Tablausers'
import AddUsers from './AddUsers'
import { obtenerusers } from '../../Redux/Users'
import { useDispatch, useSelector } from 'react-redux'
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import MuiAppBar from '@mui/material/AppBar';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import MenuPerfil from '../loggin/MenuPerfil'
const drawerWidth = 240;

const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    }),
}));

const ContenedorUser = (props) => {
    const dispatch = useDispatch()
    const rows = useSelector(store => store.users.users)
    const { open } = props
    const { appbar } = props

    React.useEffect(() => {
        const obtenerDatos = async () => {
            dispatch(obtenerusers())
        }
        obtenerDatos()
    }, [dispatch])

    const obteneruser = () => {
        dispatch(obtenerusers())
    }

    return (
        <div>
            <AppBar position="absolute" color='info' open={open} elevation={0}>
                <Toolbar
                    sx={{
                        pr: '24px', // keep right padding when drawer closed
                    }}
                >
                    <IconButton
                        edge="start"
                        color='success'
                        aria-label="open drawer"
                        onClick={appbar}
                        sx={{
                            marginRight: '36px',
                            ...(open && { display: 'none' }),
                        }}
                    >
                        <MenuIcon />
                    </IconButton>

                    <MenuPerfil />

                </Toolbar>
                <Divider />
            </AppBar>
            <br />
            <Typography variant='h4'>Usuarios</Typography>
            <br />
            <AddUsers
                obteneruser={obteneruser}
            />
            <br /> <br />
            <Tablausers
                obteneruser={obteneruser}
                rows={rows}
            />
        </div>
    )
}

export default ContenedorUser
